import { useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { checkAssistanceServiceFreeGenerateFg } from '@atlassian/editor-ai-common/utils/check-assistance-service-fg';
import { messages as experienceMessages } from '../../messages';
export var useAdditionalFooterText = function useAdditionalFooterText(_ref) {
  var configItem = _ref.configItem,
    promptTrigger = _ref.promptTrigger,
    latestPrompt = _ref.latestPrompt;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;

  // if convoAI related FF is enabled
  var convoAIBeta = checkAssistanceServiceFreeGenerateFg() || fg('platform_editor_ai_interrogate_with_convo_ai');

  // If the Rovo feature flag is enabled and user is interacting with
  // a Rovo agent, disable link warnings.
  var isLinkWarningEnabled = editorExperiment('platform_editor_ai_command_palate_improvement', 'test') ? !configItem.agent : true;

  // if it is generate or interrogate
  var isGenerateOrInterrogatePrompt = promptTrigger && ['interrogate', 'generate'].includes(promptTrigger);
  var additionalFooterText;
  if (isGenerateOrInterrogatePrompt && convoAIBeta && isLinkWarningEnabled && latestPrompt !== null && latestPrompt !== void 0 && latestPrompt.userInput) {
    // if the prompt includes a link
    var containsURL = latestPrompt.userInput.includes('http://') || latestPrompt.userInput.includes('https://');
    if (containsURL) {
      additionalFooterText = formatMessage(experienceMessages.convoAIBeta);
    }
  }
  return additionalFooterText;
};